import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Pregunta } from '../../_models/pregunta';
import { BancoPreguntasService } from '../../_services/banco-preguntas.service';
import { ListaService } from '../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { RespuestaService } from '../../_services/respuesta.service';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { RetornoFuncionalidades } from '../../_models/retorno-funcionalidades';
import { ListaItem } from '../../_models/lista-item';

@Component( {
  templateUrl: 'banco-preguntas-editar.component.html',
  selector: 'app-preguntas-editar'
} )
export class BancoPreguntasEditarComponent implements OnInit, OnDestroy {
  carInformacionInicial = true;
  formulario: FormGroup;
  formularioR: FormGroup;
  pregunta: Pregunta;
  preguntas: Pregunta[] = [];
  guardando: boolean;
  guardandoP: boolean;
  codExiste: boolean;
  codExisteR: number;
  submitted: boolean;
  submittedR: boolean;
  editando: boolean;
  editandoR: boolean;
  mostrarSeccion: boolean;
  listaTiposPreguntas: SelectItem[] = [];
  idPregunta: string;
  heroForm: FormGroup;
  respuestas: any[] = [];
  tabSeleccionado = 'INFO';
  proceso: any;
  lisTiposPreguntas: ListaItem[] = [];
  iterador: number[] = [];
  id = 0;

  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private formBuilder: FormBuilder,
               private listaService: ListaService,
               private bancoPreguntasService: BancoPreguntasService,
               private respuestasService: RespuestaService,
               private cuePreguntaServicio: CuestionarioPreguntaService,
               private confirmacionServicio: ConfirmationService ) {
    this.editando = false;
  }

  ngOnInit() {
    this.iterador.push( 0 );
    this.iterador.push( 1 );
    this.proceso = this.navServicio.getRetornoFuncionalidad( 'CUEPRE' );
    this.formularioR = this.formBuilder.group( {
      idRespuesta: [ null ],
      idPregunta: [ null ],
      codigo: [ '1', Validators.required ],
      nombre: [ 'ewsewsews', [ Validators.required, Validators.maxLength( 250 ) ] ],
      indicadorHabilitado: [ true ],
    } );

    this.route.params.subscribe( async( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.bancoPreguntasService.obtener( params[ 'id' ] ),
          this.respuestasService.listadoByPregunta( params[ 'id' ] ),
          this.bancoPreguntasService.listado()).subscribe( ( [ res, respuestas, lisPreguntas ] ) => {
          this.pregunta = res;
          this.preguntas = lisPreguntas;
          this.editando = true;
          this.codExiste = false;
          this.idPregunta = res.idPregunta;
          const array: any[] = [];
          respuestas.map( datos => {
            const pregunta = this.formBuilder.group( {
              idRespuesta: [ datos.idRespuesta ],
              idPregunta: [ datos.idPregunta ],
              codigo: [ datos.codigo, Validators.required ],
              nombre: [ datos.nombre, [ Validators.required, Validators.maxLength( 250 ) ] ],
              indicadorHabilitado: [ datos.indicadorHabilitado ],
              auditoriaUsuario: [ datos.auditoriaUsuario ],
              auditoriaFecha: [ datos.auditoriaFecha ],
              codigoExiste: [ false ],
              editando: [ true ],
              id: [ ++this.id ]
            } );
            array.push( pregunta );
          } );
          if ( respuestas.length > 0 ) {
            this.contruirFormularioRespuestas( null, array );
          } else {
            this.contruirFormularioRespuestas( res.idPregunta, null );
          }
          this.carServicios();
        } );

      } else {
        this.carServicios();
        this.preguntas = await this.bancoPreguntasService.listado().toPromise();
      }
    } );

  }

  carServicios() {
    this.formulario = this.formBuilder.group( {
      idPregunta: [ this.pregunta ? this.pregunta.idPregunta : null ],
      codigo: [ this.pregunta ? this.pregunta.codigo : null, Validators.required ],
      idTipoPregunta: [ this.pregunta ? this.pregunta.idTipoPregunta : null, Validators.required ],
      nombre: [ this.pregunta ? this.pregunta.nombre : null, [ Validators.required, Validators.maxLength( 2000 ) ] ],
      indicadorHabilitado: [ this.pregunta ? this.pregunta.indicadorHabilitado : true ],
      tipoPregunta: [ this.pregunta ? this.pregunta.tipoPregunta : null ],
    } );

    this.listaService.getMasterDetails( 'ListasTiposPreguntas' ).subscribe( res => {
      res.map( x => {
        if ( x.codigo === 'TEXTO' || x.codigo === 'SELECT' || x.codigo === 'CHECK' || x.codigo === 'TIPOFE' ) {
          this.listaTiposPreguntas.push( { label: x.nombre, value: x.idLista } );
        }
      } );
      this.lisTiposPreguntas = res;
      const codPregunta = this.pregunta ? this.obtenerItemLista( this.pregunta.idTipoPregunta ).codigo : null;
      if ( this.pregunta && codPregunta !== 'TEXTO' && codPregunta !== 'TIPOFE' ) {
        this.mostrarSeccion = true;
      } else {
        this.mostrarSeccion = false;
      }
      this.carInformacionInicial = false;
    } );
  }


  contruirFormularioRespuestas( idPregunta?: string, array?: any ) {
    if ( idPregunta ) {
      this.heroForm = this.formBuilder.group( {
        'pregunta': this.formBuilder.array( [
          this.formBuilder.group( {
            idRespuesta: [ null ],
            idPregunta: [ idPregunta ],
            codigo: [ null, Validators.required ],
            nombre: [ null, [ Validators.required, Validators.maxLength( 250 ) ] ],
            indicadorHabilitado: [ true ],
            codigoExiste: [ false ],
            editando: [ false ],
            id: [ ++this.id ]
          } ),
          this.formBuilder.group( {
            idRespuesta: [ null ],
            idPregunta: [ idPregunta ],
            codigo: [ null, Validators.required ],
            nombre: [ null, [ Validators.required, Validators.maxLength( 250 ) ] ],
            indicadorHabilitado: [ true ],
            codigoExiste: [ false ],
            editando: [ false ],
            id: [ ++this.id ]
          } )
        ] )
      } );
    } else {
      this.heroForm = this.formBuilder.group( {
        'pregunta': this.formBuilder.array( array )
      } );
    }
  }

  agregarPregunta( control: any ) {
    const pregunta = this.formBuilder.group( {
      idRespuesta: [ null ],
      idPregunta: [ this.idPregunta ],
      codigo: [ null, Validators.required ],
      nombre: [ null, [ Validators.required, Validators.maxLength( 250 ) ] ],
      indicadorHabilitado: [ true ],
      codigoExiste: [ false ],
      editando: [ false ],
      id: [ ++this.id ]
    } );
    control.push( pregunta );
  }

  removerPregunta( array, control, index ) {
    array.splice( index, 1 );
  }

  validarCodigoRespuestas( control, index ) {
    const listaRespuestasTemp = this.heroForm.get( 'pregunta' ) as UntypedFormArray;
    const listaRespuestas: any[] = [];
    listaRespuestasTemp.controls.map( x => {
      const obj = Object.assign( {}, x.value );
      listaRespuestas.push( obj );
    } );
    const codigo = control.controls.codigo;
    if ( codigo.value !== '' && codigo.value !== null && codigo.value !== undefined ) {
      if ( !!listaRespuestas.find( t => t.codigo === codigo.value && control.controls.id.value !== t.id ) ) {
        this.codExisteR = index;
        control.controls.codigoExiste.setValue( true );
      } else {
        this.codExisteR = null;
        control.controls.codigoExiste.setValue( false );
      }
    } else {
      this.codExisteR = null;
      control.controls.codigoExiste.setValue( false );
    }
  }

  get controlesRespuestas() {
    const data = this.heroForm.get( 'pregunta' ) as UntypedFormArray;
    return data;
  }

  get f() {
    return this.formulario.controls;
  }

  get fr() {
    const preg = this.heroForm.get( 'pregunta' ).value as UntypedFormArray;
    return preg;
  }

  validarCodigo() {
    this.codExiste = !!this.preguntas.find(
      t => t.codigo === this.f.codigo.value && (!this.pregunta || this.pregunta.idPregunta !== t.idPregunta) );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.codExiste ) {
      this.guardando = true;
      const datPregunta = this.formulario.value;
      if ( !datPregunta.idPregunta ) {
        this.bancoPreguntasService.agregar( datPregunta ).subscribe( res => {
          this.idPregunta = res.idPregunta;
          const iteLista = this.obtenerItemLista( datPregunta.idTipoPregunta );
          datPregunta.idPregunta = res.idPregunta;
          datPregunta.tipoPregunta = iteLista.nombre;
          datPregunta.codigo = res.codigo;
          this.pregunta = datPregunta;
          this.f.codigo.setValue( res.codigo );
          this.f.idPregunta.setValue( res.idPregunta );
          if ( iteLista.codigo !== 'TEXTO' && iteLista.codigo !== 'TIPOFE' ) {
            this.guardando = false;
            this.contruirFormularioRespuestas( res.idPregunta, null );
            this.mostrarSeccion = true;
            this.tabSeleccionado = 'PREG';
            this.navServicio.setMesage( 1 );
          } else {
            if ( this.proceso ) {
              this.crearCuestionarioPregunta( this.proceso, res, true );
            } else {
              this.guardando = false;
              this.router.navigate( [ 'apl/preguntas' ] );
              this.navServicio.setMesage( 1 );
            }
          }
        }, e => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.bancoPreguntasService.actualizar( datPregunta ).subscribe( res => {
          this.pregunta = datPregunta;
          this.guardando = false;
          this.navServicio.setMesage( 2 );
          if ( this.mostrarSeccion ) {
            this.guardando = false;
            this.tabSeleccionado = 'PREG';
            this.navServicio.setMesage( 2 );
          } else {
            this.guardando = false;
            this.router.navigate( [ 'apl/preguntas' ] );
            this.navServicio.setMesage( 2 );
          }
        }, e => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      }
    } else {
      return;
    }
  }

  goBack() {
    if ( this.formulario.dirty ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          if ( this.proceso ) {
            this.router.navigate( [ this.proceso.ruta ] );
          } else {
            this.router.navigate( [ 'apl/preguntas' ] );
          }
        }
      } );
    } else {
      if ( this.proceso ) {
        this.router.navigate( [ this.proceso.ruta ] );
      } else {
        this.router.navigate( [ 'apl/preguntas' ] );
      }
    }
  }

  onSubmitRespuestas() {
    this.submittedR = true;
    this.guardandoP = true;
    const listaRespuestasTemp = this.heroForm.get( 'pregunta' ) as UntypedFormArray;
    const listaRespuestas: any[] = [];
    listaRespuestasTemp.controls.map( x => {
      const obj = Object.assign( {}, x.value );
      listaRespuestas.push( obj );
    } );
    this.respuestas = listaRespuestas;
    if ( this.respuestas.find( x => x.nombre === null || x.nombre === undefined || x.nombre === '' || x.codigoExiste ) ) {
      this.guardandoP = false;
    } else {
      this.respuestasService.bulk( this.respuestas ).subscribe( res => {
        if ( this.proceso ) {
          this.crearCuestionarioPregunta( this.proceso, this.pregunta, false );
        } else {
          this.navServicio.setMesage( 2 );
          const array: any[] = [];
          this.id = 0;
          res.map( datos => {
            const pregunta = this.formBuilder.group( {
              idRespuesta: [ datos.idRespuesta ],
              idPregunta: [ datos.idPregunta ],
              codigo: [ datos.codigo, Validators.required],
              nombre: [ datos.nombre, [ Validators.required, Validators.maxLength( 250 ) ] ],
              indicadorHabilitado: [ datos.indicadorHabilitado ],
              auditoriaUsuario: [ datos.auditoriaUsuario ],
              auditoriaFecha: [ datos.auditoriaFecha ],
              codigoExiste: [ false ],
              editando: [ true ],
              id: [ ++this.id ]
            } );
            array.push( pregunta );
          } );
          this.contruirFormularioRespuestas( null, array );
          this.guardandoP = false;
          this.router.navigate( [ 'apl/preguntas' ] );
        }

      }, error1 => {
        this.navServicio.setMesage( 3 );
      } );
    }
  }

  goBackRespuestas() {
    const listaRespuestasTemp = this.heroForm.get( 'pregunta' ) as UntypedFormArray;
    if ( listaRespuestasTemp.controls.find( x => x.dirty === true ) ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          if ( this.proceso ) {
            this.router.navigate( [ this.proceso.ruta ] );
          } else {
            this.router.navigate( [ 'apl/preguntas' ] );
          }
        }
      } );
    } else {
      if ( this.proceso ) {
        this.router.navigate( [ this.proceso.ruta ] );
      } else {
        this.router.navigate( [ 'apl/preguntas' ] );
      }
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PREG';
        break;
      }
      default: {
        break;
      }
    }
  }

  obtenerItemLista( idLista: string ) {
    const a = this.lisTiposPreguntas.find( x => x.idLista === idLista );
    if ( a ) {
      return a;
    } else {
      return new ListaItem();
    }
  }


  crearCuestionarioPregunta( proceso: RetornoFuncionalidades, res: Pregunta, crear: boolean ) {
    this.cuePreguntaServicio.listadoPorCuestionario( proceso.idProceso ).subscribe( preguntas => {
      let maximo = 0;
      preguntas.map( ( s: CuestionarioPregunta ) => {
        if ( s.orden > maximo ) {
          maximo = s.orden;
        }
      } );
      const a: CuestionarioPregunta = {
        id: null,
        idCuestionarioPregunta: null,
        idCuestionario: proceso.idProceso,
        idPregunta: res.idPregunta,
        indicadorDescartante: false,
        orden: maximo + 1,
        indicadorHabilitado: false,
        auditoriaUsuario: null,
        auditoriaFecha: null,
        pregunta: null,
        tipoPregunta: null,
        codigoTipoPregunta: null,
        cuestionario: null,
        respuestas: []
      };
      this.cuePreguntaServicio.crear( a ).subscribe( creada => {
        if ( crear ) {
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        } else {
          this.navServicio.setMesage( 2 );
        }
        this.router.navigate( [ proceso.ruta ] );
      } );
    } );
  }


  ngOnDestroy(): void {
    this.navServicio.resetRetornoFuncionalidades();
  }
}
